export const headerOptions =[
    {name:"Home"},
    {name:"About"},
    
    {name:"Qualification"},
    {name:"Skills"},
    // {name:"Services"},
    {name:"Projects"},
    {name:"Certification"},
    {name:"Contact me"},
] 